<template>
  <v-card>
    <v-card-title>Partner informatie</v-card-title>
    <v-card-text>
      <p>
        Als bruidsparen via een van deze links een magazine aanvragen krijg jij
        er een vergoeding voor. Na het klikken op de link hebben bruidsparen 7
        dagen om een magazine aan te vragen.
      </p>
      <v-container>
        <v-row>
          <h3>Persoonlijke partner links</h3>
        </v-row>
        <v-row v-for="website in websites" :key="website.id">
          <a
            :href="`https://${website.name}?affiliate=${getAffiliateKey()}`"
            target="_blank"
            style="text-decoration: none"
          >
            <span style="text-decoration: underline">
              {{ `https://${website.name}?affiliate=${getAffiliateKey()}` }}
            </span>
            <v-icon small style="padding-left: 5px; text-decoration: none"
              >mdi-open-in-new</v-icon
            >
          </a>
        </v-row>
        <v-row v-if="!websites.length">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "AffiliateInfo",

  data: () => ({
    websites: [],
  }),

  props: {
    supplier: Object,
  },

  computed: {
    ...mapGetters({
      user: "user",
    }),
  },

  watch: {
    user: async function () {
      if (this.user.id) {
        this.websites = (await axios.get(`${this.$api}/v2/websites`)).data;
      }
    },
  },

  async mounted() {
    if (this.user.id) {
      this.websites = (await axios.get(`${this.$api}/v2/websites`)).data;
    }
  },

  methods: {
    getAffiliateKey() {
      return encodeURIComponent(this.supplier.affiliate);
    },
  },
});
</script>

<style>
</style>